export default function splitFileNameExt(filename: string) {
  const ext = filename.substr(filename.lastIndexOf('.') + 1);
  const name = filename.split('.').slice(0, -1).join('.');
  return { ext, name };
}
